import { render, staticRenderFns } from "./MelonTVScheduleModal3.vue?vue&type=template&id=63b559c2&"
import script from "./MelonTVScheduleModal3.vue?vue&type=script&lang=js&"
export * from "./MelonTVScheduleModal3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports